import { render, staticRenderFns } from "./trainingLevel.vue?vue&type=template&id=31b9cb7a&scoped=true"
import script from "./trainingLevel.vue?vue&type=script&lang=js"
export * from "./trainingLevel.vue?vue&type=script&lang=js"
import style0 from "./trainingLevel.vue?vue&type=style&index=0&id=31b9cb7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9cb7a",
  null
  
)

export default component.exports